import React, { useEffect, useState } from "react";
import moment from "moment";
import SpecialSlots from "./SpecialSlots";
import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import Slot from "../../SiteAdmin/Slot/Slot";

const days_arr = [
  { day: "Monday", type: 1, start_time: "", end_time: "", toggle: false },
  { day: "Tuesday", type: 2, start_time: "", end_time: "", toggle: false },
  { day: "Wednesday", type: 3, start_time: "", end_time: "", toggle: false },
  { day: "Thursday", type: 4, start_time: "", end_time: "", toggle: false },
  { day: "Friday", type: 5, start_time: "", end_time: "", toggle: false },
  { day: "Saturday", type: 6, start_time: "", end_time: "", toggle: false },
  { day: "Sunday", type: 7, start_time: "", end_time: "", toggle: false },
];

const AdminSlotMainComp = ({ list }) => {
  const [activeTab, setActiveTab] = useState("week");
  const [alertData, setAlertData] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const location = useLocation();
  const superAdmin = location.state?.superAdmin;
  const { type, data } = location.state;
  // console.log("superAdmin", superAdmin);
  const [days, setDays] = useState([...days_arr]);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);
  const navigate = useNavigate();

  const [dayValue, setDayValue] = useState(0);

  // useEffect(() => {
  //   const slotDays = JSON.parse(localStorage.getItem("slotDays"));
  //   if (slotDays) {
  //     setActiveTab(slotDays);
  //   } else {
  //     setActiveTab("week");
  //     localStorage.setItem("slotDays", JSON.stringify("week"));
  //   }
  // }, []);

  const handleTab = (days) => {
    setActiveTab(days);
    localStorage.setItem("slotDays", JSON.stringify(days));
  };

  const getAlertTypes = (site_id, currentDayIndex = 0) => {
    // ✅ Accept index as param
    if (site_id) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", site_id);
      post(URL.ADMIN_DAY_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [...days_arr];
            let data = [...res?.data];
            let day_type = [1, 2, 3, 4, 5, 6, 7];
            data?.map((item) => {
              if (day_type?.includes(item?.type)) {
                let indexToReplace = day_type.findIndex(
                  (i) => i === item?.type,
                );
                temp[indexToReplace] = {
                  ...temp[indexToReplace],
                  toggle: item?.start_time && item?.end_time ? true : false,
                  start_time: item?.start_time
                    ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                    : "",
                  end_time: item?.end_time
                    ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                    : "",
                };
              }
            });

            // ✅ Use the passed index, not stale dayValue from closure
            const activeDay = temp[currentDayIndex];
            if (activeDay?.start_time && activeDay?.end_time) {
              const matchingDays = temp
                .filter(
                  (d) =>
                    d.type !== activeDay.type &&
                    d.start_time === activeDay.start_time &&
                    d.end_time === activeDay.end_time,
                )
                .map((d) => d.type);
              setSelectedDays(matchingDays);
            } else {
              setSelectedDays([]);
            }
            setDays(temp);
          }
        })
        .catch((err) => console.log("err", err));
    }
  };
  const getAlertEscalation = (site_id) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", site_id);
      post(URL.ADMIN_DATE_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [];
            let data = [...res?.data];
            data?.map((item, ind) => {
              let obj = {
                ...item,
                toggle: item?.start_time && item?.end_time ? true : false,
                date: item?.for_date,
                for_date: moment(item?.for_date).format("DD-MM-YYYY"),
                start_time: item?.start_time
                  ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                  : "",
                end_time: item?.end_time
                  ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                  : "",
              };
              temp.push(obj);
            });
            setDates(temp);
            setSelectedDate(temp?.[0]?.id);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setDates([]);
    }
  };

  useEffect(() => {
    if (data?.id) {
      getAlertTypes(data?.id);
      getAlertEscalation(data?.id);
    }
  }, []);

  console.log("days", days);

  console.log("dayValue", dayValue);

  const handleDayChange = (ind) => {
    setDayValue(ind);
    // ✅ Recalculate selectedDays from current days state directly
    const currentDay = days[ind];
    if (currentDay?.start_time && currentDay?.end_time) {
      const matchingDays = days
        .filter(
          (d) =>
            d.type !== currentDay.type &&
            d.start_time === currentDay.start_time &&
            d.end_time === currentDay.end_time,
        )
        .map((d) => d.type);
      setSelectedDays(matchingDays);
    } else {
      setSelectedDays([]);
    }
  };

  return (
    <div className="">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "week" ? "active" : ""}`}
          onClick={() => handleTab("week")}
        >
          Week days
        </button>
        <button
          className={`tab-btn ${activeTab === "special" ? "active" : ""}`}
          onClick={() => handleTab("special")}
        >
          Special Holidays
        </button>
      </div>

      <div>
        {activeTab == "week" && (
          <Slot
            superAdmin={superAdmin}
            days={days}
            setDays={setDays}
            handleSubmit={() => {}}
            noEditable={true}
            selectedDays={selectedDays}
            setDayValue={handleDayChange}
            setSelectedDays={setSelectedDays}
          />
        )}
        {activeTab == "special" && (
          <SpecialSlots
            superAdmin={superAdmin}
            dates={dates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setDates={setDates}
          />
        )}
      </div>
    </div>
  );
};

export default AdminSlotMainComp;
